import { Component, OnInit, Input } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { NewsService } from '../services/news.service';
import * as $ from 'jquery'
@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.css']
})
export class NewsDetailsComponent implements OnInit {
  [x: string]: any;

  @Input("id")id ; 
  newDetail  ; 
  newsData ; 
  newId ; 
  showImages:boolean = false 
  constructor(private _Activatedroute:ActivatedRoute,private _router:Router , private news:NewsService)
   { 
    this._Activatedroute.params.subscribe(params => {
      this.id = params['id'];
       // reset and set based on new parameter this time
  });
    this.newsData = this.news.newsData
    for(let item of this.newsData)
    {
      if(item.id == this.id )
      {
        this.newDetail = item ; 
        if(item.images.length >1)
        {
          this.showImages = true 
        }
        break 
      }
    }
 
    
   }

  ngOnInit() {

    this._Activatedroute.params.subscribe (res => {
     this.id = res['id'] ; 
     this.newsData = this.news.newsData ;
    for(let item of this.newsData)
    {
      if(item.id == this.id )
      {
        this.newDetail = item 
        if(item.images.length >1)
        {
          this.showImages = true 
        }
        break 
      }
    
     
    }

    
   }); 
   
   $(document).ready(function(){
   
    $("body").on("click",".con-sub-image img",function(){
      $("#mean").attr("src",$(this).attr("src")) ;
      $(".con-sub-image img").not(this).removeClass("act");
      $(this).addClass("act")
    });


    $("body").on("click","#like",function(){
      if($(this).children("i").hasClass("fa-thumbs-o-down"))
      {
        $(this).css("background","#fff")
      }
      else
      {
        $(this).css("background","#eee")
      }
      $(this).children("i").toggleClass("fa-thumbs-o-down")
    });
   
   });
  }

   
  changeURL(tag)
  {
    
    this._router.navigate(["News/Tag",tag])
  }
  changeWritter(author)
  {
    this._router.navigate(["News/Writter",author])
  }

}
